
import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { FiTrash2, FiEdit2, FiChevronDown, FiChevronUp } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { FiSearch } from 'react-icons/fi';
import EventDetails from '../../Admin/EventDetails';
import { jwtDecode } from 'jwt-decode';
import EditEvent from './EditEventProvider';
// import EditEvent from './EditEvent'; 

const ToggleButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  margin-left: 0.5rem;
`;

const Container = styled.div`
  // padding: 4rem 2rem;
  margin-bottom: 50px;

   @media (max-width: 768px) {
    margin-bottom: 20px; 
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;

  h2 {
    color: #385963;
  }

  button {
    background-color: #385963;
    color: white;
    border: none;
    padding: 0.5rem 1rem;
    border-radius: 6px;
    cursor: pointer;
    font-size: 0.9rem;
  }

  button:hover {
    background-color: #2c4a52;
  }
     @media (max-width: 768px) {
   h2{
     font-size: 13px;
   }

   button{
      font-size: 10px;
   }

  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: white;
  box-shadow: 0 4px 10px rgba(0,0,0,0.05);

  th, td {
    padding: 1rem;
    text-align: left;
    border-bottom: 1px solid #eee;
    color: #385963;
  }

  th {
    background-color: #f9f9f9;
  }

  td:last-child {
    text-align: right;
  }

  button {
    background: none;
    border: none;
    color: #e74c3c;
    cursor: pointer;
    font-size: 1.2rem;
  }

  button:hover {
    color: #c0392b;
  }


   @media (max-width: 768px) {
    th,td{
      font-size: 14px;
    }
  }
`;

const SearchBar = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 50px;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 0.5rem 1rem;
  

  input {
    border: none;
    flex: 1;
    font-size: 1rem;
    outline: none;
    color:#385963;
  }

  svg {
    margin-right: 0.5rem;
    color: #555;
  }
`;



const ManageEvents = ({ onEditEvent }) => {

const BASE_URL = process.env.REACT_APP_BASE_URL;
const { i18n, t } = useTranslation();
const tokenString = sessionStorage.getItem("token");
const rawLang = i18n.language;
const language = rawLang.startsWith('gr') ? 'gr' : 'en';
const otherLang = language === 'gr' ? 'en' : 'gr';
const navigate = useNavigate();
const [events, setEvents] = useState([]);
const [expandedRow, setExpandedRow] = useState(null);
const [searchTerm, setSearchTerm] = useState('');
const decodedToken = jwtDecode(decodeURIComponent(tokenString));
const userId = decodedToken.sub;
   const [loggedInProvider, setLoggedInProvider] = useState(null);
const [view, setView] = useState('list'); // 'list' or 'edit'
const [editingEvent, setEditingEvent] = useState(null);



useEffect(() => {
  const fetchEvents = async () => {
    try {
      // const response = await fetch(`${BASE_URL}Event`);

        const requestBody = {
        categoryId: null, // example ID
        providerId: null, // example ID
        status: 1,
         model: {} 
      };


       const response = await fetch(`${BASE_URL}Event/search`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${tokenString}`
        },
        body: JSON.stringify(requestBody)
      });


      const data = await response.json();  // <-- THIS is the actual Events array
      setEvents(data);
    } catch (error) {
      console.error('Error fetching Events:', error);
    }
  };

  fetchEvents();
}, []);

const handleDelete = (id) => {
  if (!window.confirm(t('confirmDelete'))) return;

  // Define the function FIRST
  const deleteEvent = async () => {
    try {
      const response = await fetch(`${BASE_URL}Event/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${tokenString}`
        }
      });

      if (!response.ok) {
        const errorMessage = await response.text();
        console.error("Error response:", errorMessage);
        throw new Error(`Failed to delete Event: ${errorMessage}`);
      }
      // Remove the Events from state only if deletion succeeded
      setEvents(prev => prev.filter(d => d.id !== id));

    } catch (error) {
      console.error('Error deleting Events:', error);
      alert(t('errorDeletingEvents') || "Cannot delete this Events. It may be in use.");
    }
  };

  deleteEvent();
};

const filteredEvents = Array.isArray(events)
  ? events.filter((Events) => {
      const name1 = Events?.name?.[language]?.toLowerCase() || '';
      const name2 = Events?.name?.[otherLang]?.toLowerCase() || '';
      const term = searchTerm.toLowerCase();
      return name1.includes(term) || name2.includes(term);
    })
  : [];

const handleEdit = (event) => {
  setEditingEvent(event);
  setView('edit');  // switch to edit mode
};

  return (
    <Container>

       <SearchBar>
            <FiSearch />
            <input
              type="text"
              placeholder={i18n.t('searchByName')}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </SearchBar>

      <Table>
        <thead>
          <tr>
            <th>{t('name')}</th>
            <th>{t('actions')}</th>
          </tr>
        </thead>
        <tbody>
          {filteredEvents.map((event) => (
            <React.Fragment key={event.id}>
              <tr>
                {/* <td>{event.name[language]}</td> */}
                <td>
                  {event.name[language]}{' '}
                  <span style={{ color: '#888' }}>
                    ({event.name[otherLang]})
                  </span>
                </td>
                <td style={{ textAlign: 'right' }}>
                  <ToggleButton onClick={() => setExpandedRow(expandedRow === event.id ? null : event.id)}>
                    {expandedRow === event.id ? <FiChevronUp /> : <FiChevronDown />}
                  </ToggleButton>
                  <ToggleButton onClick={() => onEditEvent(event)}>
                    <FiEdit2 />
                  </ToggleButton>
                  <ToggleButton onClick={() => handleDelete(event.id)}>
                    <FiTrash2 />
                  </ToggleButton>
                </td>
              </tr>
              {expandedRow === event.id && (
                <tr>
                  <td colSpan="2">
                    <EventDetails event={event}  />
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </Table>

      {editingEvent && (
        <EditEvent
          event={editingEvent}
          onCancel={() => setEditingEvent(null)}
          onSaved={() => {
            setEditingEvent(null);
            // Optionally refetch or update local state
          }}
        />
      )}
      

    </Container>

    
  );
};

export default ManageEvents;


